const successResponseHandler = (setSectionNumber: any, type: string, setLoading: any, list?: string[]) => {
	switch (type) {
		case "email-verify":
		case "sms-email-verify":
			// to check if there is more accounts adn render page based on that
			if (list) {
				const isList = containsUserList(list);
				isList ? setSectionNumber(5) : setSectionNumber(6);
				setLoading(false);
			}
			break;
		case "email-send":
			setSectionNumber(2);
			setLoading(false);
			break;
		case "sms-send":
			setLoading(false);
			break;
		case "sms-verify":
			setSectionNumber(4);
			setLoading(false);
			break;
		case "set-password":
			setSectionNumber(7);
			setLoading(false);
			break;
	}
};

const containsUserList = (list: string[] | undefined): boolean => {
	return list?.length! > 1;
};

export { successResponseHandler };
